import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import gridCellData from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/gridCellData';
import GridColumnInspectorHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper';
import ForwardStepsLocations, {
    ForwardStepsLocationsData,
    ForwardStepsLocationsDataKeys,
    ForwardStepsLocationsDisplayOptions,
} from '../../../../components/forward-steps-locations/ForwardStepsLocations';

const ForwardStepsLocationsColumnTemplate = (props: CellTemplateProps) => {
    const data = gridCellData(props);

    return (
        <>
            <GridColumnInspectorHelper cellProps={props}>
                {(inspectorId, disableInspectorForm) => (
                    <ForwardStepsLocations
                        disableInspectorForm={disableInspectorForm}
                        inspectorId={inspectorId}
                        data={data}
                        defaultProps={ForwardStepsLocationsColumnTemplateDefaultProps}
                    />
                )}
            </GridColumnInspectorHelper>
        </>
    );
};

export const ForwardStepsLocationsColumnTemplateDefaultProps =
    {
        multipleRouteLocationOptions:
        {
            routeLocationDisplayOptions:
            {
                hideLocation : true,
                logisticUnitDisplayOptions:
                {
                    hideName : true
                }
            }
        }
    } as ForwardStepsLocationsDisplayOptions;

export const ForwardStepsLocationsColumnTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current,
    };
};

export type ForwardStepsLocationsColumnTemplateData = ForwardStepsLocationsData & {};

export const ForwardStepsLocationsColumnTemplateDataKeys = [...ForwardStepsLocationsDataKeys];

export default ForwardStepsLocationsColumnTemplate;
